import { Button } from '@/components/ui/button';

const trainings = [
  { title: 'Warsztaty NVC — komunikacja bez przemocy', desc: 'Radni uczą się słuchać i negocjować.' },
  { title: 'Symulacja rozprawy — zjawisko stalkingu', desc: 'Profilaktyka obniża koszty interwencji.' },
  { title: 'Wystąpienia publiczne i praca w radzie', desc: 'Skuteczna komunikacja w samorządzie.' },
  { title: 'Unplugged / Archipelag Skarbów', desc: 'Programy rekomendowane przez MEN.' },
];

const SamorzadySection = () => {
  return (
    <section id="samorzady" className="py-16 lg:py-24 bg-background">
      <div className="container">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-10 text-center">Dla samorządów</h2>
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="space-y-4">
            {trainings.map((t, i) => (
              <div key={i} className="bg-card rounded-panel p-5 border hover:shadow-sm transition-shadow">
                <h3 className="font-heading font-bold mb-1">{t.title}</h3>
                <p className="text-sm text-muted-foreground">{t.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-primary rounded-panel p-8 text-primary-foreground">
            <h3 className="font-heading font-bold text-2xl mb-4">Szkolenie MRG — 0 zł z budżetu zadaniowego</h3>
            <p className="opacity-90 mb-4 leading-relaxed">
              Szkolenia finansowane z Gminnego Programu Profilaktyki. Zero obciążenia budżetu gminy.
            </p>
            <p className="text-sm opacity-80 mb-6">
              Podstawa prawna: art. 41 ustawy o wychowaniu w trzeźwości
            </p>
            <Button asChild className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold">
              <a href="mailto:kuznialisewo@gmail.com">Zamów Memorandum</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SamorzadySection;
